<script setup lang="ts">
const { faqsLink, supportLink, supportIcon, supportLinkName } = useSupportLinks()
const { t } = useLocale()
const { trackClickWhatsApp } = useGTM()

const bothLinks = computed(() => !!faqsLink.value && !!supportLink.value)

const clickWhatsApp = () => {
  trackClickWhatsApp()
}
</script>

<template>
  <section class="flex flex-row items-center" :class="{ 'justify-center': !bothLinks }">
    <div
      v-if="faqsLink"
      class="w-1/2 p-4 text-center text-sm"
      :class="{ 'border-r border-r-mcd-secondaryLightGrey': bothLinks }"
    >
      <h4 class="mb-2 font-bold">{{ t('help.links.faqs.title') }}</h4>
      <NuxtLink class="text-mcd-secondaryBlue" :to="faqsLink" target="_blank">
        {{ t('help.links.faqs.linkText') }}
      </NuxtLink>
    </div>
    <div v-if="supportLink" class="w-1/2 p-4 text-center text-sm">
      <h4 class="mb-2 font-bold">{{ t('help.links.whatsapp.title') }}</h4>
      <NuxtLink
        class="mx-auto flex w-fit flex-row items-center gap-3"
        :to="supportLink"
        target="_blank"
        @click="clickWhatsApp"
      >
        <img class="h-[1.15rem] w-[1.15rem]" :src="supportIcon" :alt="supportLinkName" />
        <p class="text-mcd-secondaryBlue">
          {{ supportLinkName || t('help.links.whatsapp.linkText') }}
        </p>
      </NuxtLink>
    </div>
  </section>
</template>
